import React, { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import API_BASE_URL from "../config";

export default function UploadDocuments() {
  const [files, setFiles] = useState({
    aadhaar: null,
    pan: null,
    bank: null,
    degree: null,
    passport: null,
  });

  const token = sessionStorage.getItem("token");

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, files } = e.target;
    setFiles((prev) => ({
      ...prev,
      [name]: files[0],
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const formData = new FormData();
  Object.keys(files).forEach((key) => {
    if (files[key]) {
      formData.append(key, files[key]);
    }
  });

  try {
    const response = await fetch(`${API_BASE_URL}/api/documents/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`, 
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Upload failed");
    }

    const result = await response.text();
    setMessage(result);
  } catch (error) {
    console.error("Error uploading documents:", error);
    setMessage("Failed to upload documents.");
  }
};


  const goBack = () => {
    window.history.back();
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <button onClick={goBack} style={styles.backButton}>
          <FaArrowLeft style={{ marginRight: "8px" }} />
          Back
        </button>
        <h2 style={styles.title}>Upload Documents</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          {[
            { label: "Aadhaar", name: "aadhaar", required: true },
            { label: "PAN", name: "pan", required: true },
            { label: "Bank Passbook", name: "bank", required: true },
            { label: "Degree Certificate", name: "degree", required: true },
            { label: "Passport (Optional)", name: "passport", required: false },
          ].map((doc) => (
            <div style={styles.row} key={doc.name}>
              <label style={styles.label}>{doc.label}:</label>
              <input
                type="file"
                name={doc.name}
                onChange={handleChange}
                required={doc.required}
                style={styles.input}
              />
            </div>
          ))}

          <div style={styles.buttonWrapper}>
            <button type="submit" style={styles.button}>Upload</button>
          </div>
        </form>

        {message && <p style={styles.message}>{message}</p>}
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    background: "#eef2f3",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  container: {
    width: "100%",
    
    maxWidth: "1000px", // bigger width
    backgroundColor: "#ffffff",
    padding: "40px", // bigger padding
    borderRadius: "12px",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
  },
  title: {
    textAlign: "center",
    color: "#333",
    marginBottom: "25px",
    fontSize: "26px",
  },
  form: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr", // 2-column layout
    gap: "40px 50px", // row-gap and column-gap
    alignItems: "center",
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  label: {
    fontWeight: "600",
    color: "#444",
    fontSize: "14px",
    flexShrink: 0,
    minWidth: "130px",
  },
  input: {
    flex: 1,
    padding: "8px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    backgroundColor: "#f5f5f5",
    width: "100%",
  },
  buttonWrapper: {
    gridColumn: "1 / span 2", // button takes full row
    textAlign: "center",
    marginTop: "20px",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "#fff",
    fontSize: "14px",
    fontWeight: "bold",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  message: {
    marginTop: "20px",
    fontWeight: "bold",
    textAlign: "center",
    color: "#006600",
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    background: "transparent",
    border: "none",
    color: "#4CAF50",
    fontWeight: "bold",
    cursor: "pointer",
    fontSize: "16px",
  },
};